import { render, staticRenderFns } from "./BillCreationSlider.vue?vue&type=template&id=88d6b11c&scoped=true&"
import script from "./BillCreationSlider.vue?vue&type=script&lang=ts&"
export * from "./BillCreationSlider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d6b11c",
  null
  
)

export default component.exports